"use strict";
// https://github.com/Chia-Network/chia-blockchain/blob/main/chia/protocols/wallet_protocol.py
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RespondSESInfo = exports.RequestSESInfo = exports.RespondChildren = exports.RequestChildren = exports.CoinStateUpdate = exports.RespondToCoinUpdates = exports.RegisterForCoinUpdates = exports.RespondToPhUpdates = exports.RegisterForPhUpdates = exports.CoinState = exports.RespondHeaderBlocks = exports.RejectHeaderBlocks = exports.RequestHeaderBlocks = exports.RejectAdditionsRequest = exports.RespondAdditions = exports.RequestAdditions = exports.RejectRemovalsRequest = exports.RespondRemovals = exports.RequestRemovals = exports.RejectHeaderRequest = exports.RespondBlockHeader = exports.RequestBlockHeader = exports.NewPeakWallet = exports.TransactionAck = exports.SendTransaction = exports.RejectPuzzleSolution = exports.RespondPuzzleSolution = exports.PuzzleSolutionResponse = exports.RequestPuzzleSolution = void 0;
const fields_1 = __importDefault(require("./fields"));
const spend_bundle_1 = require("./spend_bundle");
const coin_1 = require("./coin");
const header_block_1 = require("./header_block");
class RequestPuzzleSolution {
}
__decorate([
    fields_1.default.Bytes(32)
], RequestPuzzleSolution.prototype, "coinName", void 0);
__decorate([
    fields_1.default.Uint(32)
], RequestPuzzleSolution.prototype, "height", void 0);
exports.RequestPuzzleSolution = RequestPuzzleSolution;
class PuzzleSolutionResponse {
}
__decorate([
    fields_1.default.Bytes(32)
], PuzzleSolutionResponse.prototype, "coinName", void 0);
__decorate([
    fields_1.default.Uint(32)
], PuzzleSolutionResponse.prototype, "height", void 0);
__decorate([
    fields_1.default.SExp()
], PuzzleSolutionResponse.prototype, "puzzle", void 0);
__decorate([
    fields_1.default.SExp()
], PuzzleSolutionResponse.prototype, "solution", void 0);
exports.PuzzleSolutionResponse = PuzzleSolutionResponse;
class RespondPuzzleSolution {
}
__decorate([
    fields_1.default.Object(PuzzleSolutionResponse)
], RespondPuzzleSolution.prototype, "response", void 0);
exports.RespondPuzzleSolution = RespondPuzzleSolution;
class RejectPuzzleSolution {
}
__decorate([
    fields_1.default.Bytes(32)
], RejectPuzzleSolution.prototype, "coinName", void 0);
__decorate([
    fields_1.default.Uint(32)
], RejectPuzzleSolution.prototype, "height", void 0);
exports.RejectPuzzleSolution = RejectPuzzleSolution;
class SendTransaction {
}
__decorate([
    fields_1.default.Object(spend_bundle_1.SpendBundle)
], SendTransaction.prototype, "transaction", void 0);
exports.SendTransaction = SendTransaction;
class TransactionAck {
}
__decorate([
    fields_1.default.Bytes(32)
], TransactionAck.prototype, "txid", void 0);
__decorate([
    fields_1.default.Uint(8)
], TransactionAck.prototype, "status", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.String)
], TransactionAck.prototype, "error", void 0);
exports.TransactionAck = TransactionAck;
class NewPeakWallet {
}
__decorate([
    fields_1.default.Bytes(32)
], NewPeakWallet.prototype, "headerHash", void 0);
__decorate([
    fields_1.default.Uint(32)
], NewPeakWallet.prototype, "height", void 0);
__decorate([
    fields_1.default.Uint(128)
], NewPeakWallet.prototype, "weight", void 0);
__decorate([
    fields_1.default.Uint(32)
], NewPeakWallet.prototype, "forkPointWithPreviousPeak", void 0);
exports.NewPeakWallet = NewPeakWallet;
class RequestBlockHeader {
}
__decorate([
    fields_1.default.Uint(32)
], RequestBlockHeader.prototype, "height", void 0);
exports.RequestBlockHeader = RequestBlockHeader;
class RespondBlockHeader {
}
__decorate([
    fields_1.default.Object(header_block_1.HeaderBlock)
], RespondBlockHeader.prototype, "headerBlock", void 0);
exports.RespondBlockHeader = RespondBlockHeader;
class RejectHeaderRequest {
}
__decorate([
    fields_1.default.Uint(32)
], RejectHeaderRequest.prototype, "height", void 0);
exports.RejectHeaderRequest = RejectHeaderRequest;
class RequestRemovals {
}
__decorate([
    fields_1.default.Uint(32)
], RequestRemovals.prototype, "height", void 0);
__decorate([
    fields_1.default.Bytes(32)
], RequestRemovals.prototype, "headerHash", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.List(fields_1.default.Bytes(32)))
], RequestRemovals.prototype, "coinNames", void 0);
exports.RequestRemovals = RequestRemovals;
class RespondRemovals {
}
__decorate([
    fields_1.default.Uint(32)
], RespondRemovals.prototype, "height", void 0);
__decorate([
    fields_1.default.Bytes(32)
], RespondRemovals.prototype, "headerHash", void 0);
__decorate([
    fields_1.default.List(fields_1.default.Tuple([fields_1.default.Bytes(32), fields_1.default.Optional(fields_1.default.Object(coin_1.Coin))]))
], RespondRemovals.prototype, "coins", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.List(fields_1.default.Tuple([fields_1.default.Bytes(32), fields_1.default.Bytes()])))
], RespondRemovals.prototype, "proofs", void 0);
exports.RespondRemovals = RespondRemovals;
class RejectRemovalsRequest {
}
__decorate([
    fields_1.default.Uint(32)
], RejectRemovalsRequest.prototype, "height", void 0);
__decorate([
    fields_1.default.Bytes(32)
], RejectRemovalsRequest.prototype, "headerHash", void 0);
exports.RejectRemovalsRequest = RejectRemovalsRequest;
class RequestAdditions {
}
__decorate([
    fields_1.default.Uint(32)
], RequestAdditions.prototype, "height", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.Bytes(32))
], RequestAdditions.prototype, "headerHash", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.List(fields_1.default.Bytes(32)))
], RequestAdditions.prototype, "puzzleHashes", void 0);
exports.RequestAdditions = RequestAdditions;
class RespondAdditions {
}
__decorate([
    fields_1.default.Uint(32)
], RespondAdditions.prototype, "height", void 0);
__decorate([
    fields_1.default.Bytes(32)
], RespondAdditions.prototype, "headerHash", void 0);
__decorate([
    fields_1.default.List(fields_1.default.Tuple([fields_1.default.Bytes(32), fields_1.default.List(fields_1.default.Object(coin_1.Coin))]))
], RespondAdditions.prototype, "coins", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.List(fields_1.default.Tuple([
        fields_1.default.Bytes(32),
        fields_1.default.Bytes(),
        fields_1.default.Optional(fields_1.default.Bytes())
    ])))
], RespondAdditions.prototype, "proofs", void 0);
exports.RespondAdditions = RespondAdditions;
class RejectAdditionsRequest {
}
__decorate([
    fields_1.default.Uint(32)
], RejectAdditionsRequest.prototype, "height", void 0);
__decorate([
    fields_1.default.Bytes(32)
], RejectAdditionsRequest.prototype, "headerHash", void 0);
exports.RejectAdditionsRequest = RejectAdditionsRequest;
class RequestHeaderBlocks {
}
__decorate([
    fields_1.default.Uint(32)
], RequestHeaderBlocks.prototype, "startHeight", void 0);
__decorate([
    fields_1.default.Uint(32)
], RequestHeaderBlocks.prototype, "endHeight", void 0);
exports.RequestHeaderBlocks = RequestHeaderBlocks;
class RejectHeaderBlocks {
}
__decorate([
    fields_1.default.Uint(32)
], RejectHeaderBlocks.prototype, "startHeight", void 0);
__decorate([
    fields_1.default.Uint(32)
], RejectHeaderBlocks.prototype, "endHeight", void 0);
exports.RejectHeaderBlocks = RejectHeaderBlocks;
class RespondHeaderBlocks {
}
__decorate([
    fields_1.default.Uint(32)
], RespondHeaderBlocks.prototype, "startHeight", void 0);
__decorate([
    fields_1.default.Uint(32)
], RespondHeaderBlocks.prototype, "endHeight", void 0);
__decorate([
    fields_1.default.List(fields_1.default.Object(header_block_1.HeaderBlock))
], RespondHeaderBlocks.prototype, "headerBlocks", void 0);
exports.RespondHeaderBlocks = RespondHeaderBlocks;
class CoinState {
}
__decorate([
    fields_1.default.Object(coin_1.Coin)
], CoinState.prototype, "coin", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.Uint(32))
], CoinState.prototype, "spentHeight", void 0);
__decorate([
    fields_1.default.Optional(fields_1.default.Uint(32))
], CoinState.prototype, "createdHeight", void 0);
exports.CoinState = CoinState;
class RegisterForPhUpdates {
}
__decorate([
    fields_1.default.List(fields_1.default.Bytes(32))
], RegisterForPhUpdates.prototype, "puzzleHashes", void 0);
__decorate([
    fields_1.default.Uint(32)
], RegisterForPhUpdates.prototype, "minHeight", void 0);
exports.RegisterForPhUpdates = RegisterForPhUpdates;
class RespondToPhUpdates {
}
__decorate([
    fields_1.default.List(fields_1.default.Bytes(32))
], RespondToPhUpdates.prototype, "puzzleHashes", void 0);
__decorate([
    fields_1.default.Uint(32)
], RespondToPhUpdates.prototype, "minHeight", void 0);
__decorate([
    fields_1.default.List(fields_1.default.Object(CoinState))
], RespondToPhUpdates.prototype, "coinStates", void 0);
exports.RespondToPhUpdates = RespondToPhUpdates;
class RegisterForCoinUpdates {
}
__decorate([
    fields_1.default.List(fields_1.default.Bytes(32))
], RegisterForCoinUpdates.prototype, "coinIds", void 0);
__decorate([
    fields_1.default.Uint(32)
], RegisterForCoinUpdates.prototype, "minHeight", void 0);
exports.RegisterForCoinUpdates = RegisterForCoinUpdates;
class RespondToCoinUpdates {
}
__decorate([
    fields_1.default.List(fields_1.default.Bytes(32))
], RespondToCoinUpdates.prototype, "coinIds", void 0);
__decorate([
    fields_1.default.Uint(32)
], RespondToCoinUpdates.prototype, "minHeight", void 0);
__decorate([
    fields_1.default.List(fields_1.default.Object(CoinState))
], RespondToCoinUpdates.prototype, "coinStates", void 0);
exports.RespondToCoinUpdates = RespondToCoinUpdates;
class CoinStateUpdate {
}
__decorate([
    fields_1.default.Uint(32)
], CoinStateUpdate.prototype, "height", void 0);
__decorate([
    fields_1.default.Uint(32)
], CoinStateUpdate.prototype, "forkHeight", void 0);
__decorate([
    fields_1.default.Bytes(32)
], CoinStateUpdate.prototype, "peakHash", void 0);
__decorate([
    fields_1.default.List(fields_1.default.Object(CoinState))
], CoinStateUpdate.prototype, "items", void 0);
exports.CoinStateUpdate = CoinStateUpdate;
class RequestChildren {
}
__decorate([
    fields_1.default.Bytes(32)
], RequestChildren.prototype, "coinName", void 0);
exports.RequestChildren = RequestChildren;
class RespondChildren {
}
__decorate([
    fields_1.default.List(fields_1.default.Object(CoinState))
], RespondChildren.prototype, "coinStates", void 0);
exports.RespondChildren = RespondChildren;
class RequestSESInfo {
}
__decorate([
    fields_1.default.Uint(32)
], RequestSESInfo.prototype, "height", void 0);
__decorate([
    fields_1.default.Uint(32)
], RequestSESInfo.prototype, "endHeight", void 0);
exports.RequestSESInfo = RequestSESInfo;
class RespondSESInfo {
}
__decorate([
    fields_1.default.List(fields_1.default.Bytes(32))
], RespondSESInfo.prototype, "coinRewardChainHash", void 0);
__decorate([
    fields_1.default.List(fields_1.default.List(fields_1.default.Uint(32)))
], RespondSESInfo.prototype, "heights", void 0);
exports.RespondSESInfo = RespondSESInfo;
//# sourceMappingURL=wallet_protocol.js.map